import { render, staticRenderFns } from "./paysmsorder.vue?vue&type=template&id=2f360fc8&"
import script from "./paysmsorder.vue?vue&type=script&lang=ts&"
export * from "./paysmsorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "paysmsorder.vue"
export default component.exports